import React from "react";

interface TasksFiltersIconProps {
  className?: string;
}

export const TasksFiltersIcon = ({ className }: TasksFiltersIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21.668 0.75C22.2695 0.75 22.6849 1.03646 22.9141 1.60938C23.1719 2.18229 23.0859 2.68359 22.6562 3.11328L14.793 10.9336V21.375C14.793 21.9766 14.5208 22.3919 13.9766 22.6211C13.4323 22.8789 12.9453 22.8073 12.5156 22.4062L9.76562 20C9.45052 19.7422 9.29297 19.3984 9.29297 18.9688V10.9336L1.42969 3.11328C1 2.68359 0.89974 2.18229 1.12891 1.60938C1.38672 1.03646 1.81641 0.75 2.41797 0.75H21.668ZM13.418 10.375L21.668 2.125H2.41797L10.668 10.375V18.9688L13.418 21.375V10.375Z" />
  </svg>
);

TasksFiltersIcon.defaultProps = {
  className: "",
};
